import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="password-toggle"
export default class extends Controller {
  static targets = ["input", "showIcon", "hideIcon", "button"];

  connect() {
    this.isVisible = false;
    this.updateVisibility();
  }

  toggle() {
    this.isVisible = !this.isVisible;
    this.updateVisibility();
  }

  updateVisibility() {
    if (this.hasInputTarget) {
      this.inputTarget.type = this.isVisible ? "text" : "password";
    }

    if (this.hasShowIconTarget && this.hasHideIconTarget) {
      this.showIconTarget.classList.toggle("hidden", this.isVisible);
      this.hideIconTarget.classList.toggle("hidden", !this.isVisible);
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-pressed", this.isVisible.toString());
    }
  }
}